import { render, staticRenderFns } from "./quick_config_pop.vue?vue&type=template&id=0802f806&scoped=true"
import script from "./quick_config_pop.vue?vue&type=script&lang=js"
export * from "./quick_config_pop.vue?vue&type=script&lang=js"
import style0 from "./quick_config_pop.vue?vue&type=style&index=0&id=0802f806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0802f806",
  null
  
)

export default component.exports